import {
  Frequency,
  Input,
  validateFrequency,
  validateInput,
  ValidationFunction,
} from "basis";

export const liabilityTypeOptions = [
  { label: "Mortgage ", value: "mortgage" },
  { label: "Rent / board", value: "rent / board" },
  { label: "Motor loan", value: "motor loan" },
  { label: "Credit card", value: "credit card" },
  { label: "Personal loan", value: "personal loan" },
  { label: "BNPL (buy now, pay later)", value: "BNPL (buy now, pay later)" },
  { label: "Other", value: "other" },
] as const;

export const validateMinAmount: ValidationFunction<typeof Input> = (
  val,
  props,
) => {
  const errors = validateInput(val, props);
  if (errors) {
    return errors;
  }
  const number = Number(val);
  if (number < 1) {
    return "Amount must be at least $1";
  }

  return null;
};

export const validateMinFrequency: ValidationFunction<typeof Frequency> = (
  val,
  props,
) => {
  const errors = validateFrequency(val, props);
  if (errors) {
    return errors;
  }
  const number = Number(val.amount);
  if (number < 1) {
    return {
      amount: "Amount must be at least $1",
    };
  }

  return null;
};
